export function getTransform(xAlign, yAlign) {
    let translateX = '-50%';
    let translateY = '-100%';
    if (xAlign === 'left') {
        translateX = '0';
    }
    else if (xAlign === 'right') {
        translateX = '-100%';
    }
    if (yAlign === 'center') {
        translateY = '-50%';
    }
    else if (yAlign === 'bottom') {
        translateY = '0';
    }
    return `translate(${translateX}, ${translateY})`;
}
//# sourceMappingURL=tooltipHelper.js.map